import { useEffect } from 'react'
import { CSSTransition } from 'react-transition-group'
import { IconX, IconCircleCheckFilled } from '@tabler/icons-react'

import Text from 'components/ui/text'

interface NotificationToastProps {
  title: string
  message: string
  duration: number
  show: boolean
  onClose: () => void
  noTimeout?: boolean
}

export const NotificationToast = ({
  title,
  message,
  duration,
  show,
  onClose,
  noTimeout = false,
}: NotificationToastProps) => {
  useEffect(() => {
    if (show && !noTimeout) {
      const timer = setTimeout(onClose, duration)
      return () => clearTimeout(timer)
    }
  }, [show, duration, onClose, noTimeout])

  return (
    <CSSTransition in={show} timeout={300} classNames="slide" unmountOnExit>
      <div className="tw-relative tw-right-4 tw-bg-white tw-transition tw-p-4 tw-animate-fadeIn tw-pointer-events-auto tw-rounded-lg tw-border tw-border-black/10 tw-border-solid tw-shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.05),_0px_4px_6px_-4px_rgba(0,0,0,0.03)]">
        <IconX
          role="button"
          className="tw-absolute tw-top-2 tw-right-2 tw-text-zinc-400 tw-cursor-pointer"
          onClick={onClose}
        />
        <div className="tw-flex tw-items-flex-start tw-gap-3">
          <IconCircleCheckFilled
            className="tw-text-emerald-500"
            width={20}
            height={20}
          />
          <div className="tw-flex tw-flex-grow tw-flex-col">
            <Text className="tw-m-0 tw-p-0 tw-text-sm tw-font-bold">
              {title}
            </Text>
            <Text className="tw-m-0 tw-p-0 tw-text-sm">{message}</Text>
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}
